export type TickbirdRuntimeConfig = {
  apiBaseUrl?: string;
  oidcAuthority?: string;
  oidcClientId?: string;
  oidcScope?: string;
  oidcAudience?: string;
  oidcUseServiceWorker?: string;
  oidcUseDpop?: string;
  /**
   * 允许嵌入 Tickbird 并与其建立父子通信的宿主 Origin。
   *
   * 部署模板走 `envsubst`，生成不了 JSON 数组，所以约定传逗号分隔字符串；
   * 解析、去空白与 Origin 合法性校验都在 `surfaces/embedded/embedded-config.ts` 里做。
   * 留空时允许任意宿主嵌入并建链；填写 Origin 时只允许列表中的宿主。
   */
  embeddedParentOrigins?: string | string[];
  /** 父子通信协议版本；仅支持当前实现版本，不匹配配置会告警并使用实现版本。 */
  embeddedProtocolVersion?: number | string;
  /** "在完整工作台打开"的目标地址；未配置时隐藏该入口。 */
  embeddedStandaloneUrl?: string;
};

declare global {
  interface Window {
    __TICKBIRD_RUNTIME_CONFIG__?: TickbirdRuntimeConfig;
  }
}

export const runtimeConfig = window.__TICKBIRD_RUNTIME_CONFIG__ ?? {};
